export default {
  permissions: []
}
